import React from 'react';
import { Modal } from 'react-bootstrap';

import InputField from '@components/InputField';
import SelectOptions from '@components/SelectOptions';

const AddNewTaskModal = ({
	onModalCancel,
	showModal,
	taskFormInputData,
	stageTaskList,
	handleAddTaskFormChange,
	errors,
	loading,
	onSubmit
}) => {
	const deliverableOptions =
		stageTaskList?.map((stage) => ({
			value: stage.subTask[0].deliverableId,
			label: stage.subTask[0].deliverableName
		})) || [];

	return (
		<Modal show={showModal} onHide={() => onModalCancel()} centered>
			<div className="common-popup shadow-24dp">
				<Modal.Header closeButton>
					<h3 className="semibold-16 mb-0">Add new task</h3>
				</Modal.Header>
				<Modal.Body>
					<div className="common-popup-body">
						<div className="container px-0">
							<div className="row">
								<div className="col-md-12">
									<InputField
										value={taskFormInputData.taskName}
										onChangeHandler={handleAddTaskFormChange}
										name="taskName"
										label="taskName"
										id="t-name"
										labelTitle="Task name*"
										errors={errors?.taskName}
									/>
								</div>
								<div className="col-md-12">
									<SelectOptions
										value={taskFormInputData.deliverableName}
										onChangeHandler={handleAddTaskFormChange}
										name="deliverableName"
										id="deliverableName"
										labelTitle="Deliverable*"
										options={deliverableOptions}
										errors={errors?.deliverableName}
									/>
								</div>
								<div className="col-md-12">
									<InputField
										value={taskFormInputData.dueDate}
										onChangeHandler={handleAddTaskFormChange}
										type="date"
										name="dueDate"
										label="dueDate"
										id="t-due-date"
										labelTitle="Task due date*"
										errors={errors?.dueDate}
									/>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={() => onModalCancel()}>
							Cancel
						</button>
						<button disabled={loading} className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default AddNewTaskModal;
